import React from "react";
import GallerySection from "../components/core/GallerySection";
import Footer from "../components/common/Footer";

const Gallery = () => {
	return (
		<>
			<GallerySection />;
			<Footer />
		</>
	);
};

export default Gallery;
